// @ts-nocheck
import React from 'react';
import initialState from '/root/workspace/jst-gyl_53Ms/src/.prodAdmin/.umi-production/plugin-initial-state/models/initialState';
import model0 from "/root/workspace/jst-gyl_53Ms/src/models/useAfterSalesProcessingResults";
import model1 from "/root/workspace/jst-gyl_53Ms/src/models/useAfterSalesQuestionType";
import model2 from "/root/workspace/jst-gyl_53Ms/src/models/useAutoAddPriceConfig";
import model3 from "/root/workspace/jst-gyl_53Ms/src/models/useBeWorthSell";
import model4 from "/root/workspace/jst-gyl_53Ms/src/models/useBreakPriceDrawer";
import model5 from "/root/workspace/jst-gyl_53Ms/src/models/useCardInfo";
import model6 from "/root/workspace/jst-gyl_53Ms/src/models/useCooActivities";
import model7 from "/root/workspace/jst-gyl_53Ms/src/models/useCoopChannelSupplier";
import model8 from "/root/workspace/jst-gyl_53Ms/src/models/useDistributionStrategyLog";
import model9 from "/root/workspace/jst-gyl_53Ms/src/models/useExperienceFastOrderGoods";
import model10 from "/root/workspace/jst-gyl_53Ms/src/models/useExperienceFastOrderGuide";
import model11 from "/root/workspace/jst-gyl_53Ms/src/models/useExpressInterception";
import model12 from "/root/workspace/jst-gyl_53Ms/src/models/useFindCoopAccess";
import model13 from "/root/workspace/jst-gyl_53Ms/src/models/useFreshmanLabelList";
import model14 from "/root/workspace/jst-gyl_53Ms/src/models/useGetDistributeAftersaleCount";
import model15 from "/root/workspace/jst-gyl_53Ms/src/models/useGoodsChangedNotify";
import model16 from "/root/workspace/jst-gyl_53Ms/src/models/useGoodsRule";
import model17 from "/root/workspace/jst-gyl_53Ms/src/models/useGoodsShelf";
import model18 from "/root/workspace/jst-gyl_53Ms/src/models/useHasBindShop";
import model19 from "/root/workspace/jst-gyl_53Ms/src/models/useHasDistributionGoodsData";
import model20 from "/root/workspace/jst-gyl_53Ms/src/models/useIKnowSupport";
import model21 from "/root/workspace/jst-gyl_53Ms/src/models/useInitAfterSaleSelect";
import model22 from "/root/workspace/jst-gyl_53Ms/src/models/useMobileVisitorManageQR";
import model23 from "/root/workspace/jst-gyl_53Ms/src/models/usePartnerPublic";
import model24 from "/root/workspace/jst-gyl_53Ms/src/models/usePartnership";
import model25 from "/root/workspace/jst-gyl_53Ms/src/models/usePerfectExpirePlatform";
import model26 from "/root/workspace/jst-gyl_53Ms/src/models/usePlatformAuto";
import model27 from "/root/workspace/jst-gyl_53Ms/src/models/usePlatformImageDeals";
import model28 from "/root/workspace/jst-gyl_53Ms/src/models/usePriceSyncTool";
import model29 from "/root/workspace/jst-gyl_53Ms/src/models/useQueryNotSetDefaultRule";
import model30 from "/root/workspace/jst-gyl_53Ms/src/models/useQueryPartnerStatusNum";
import model31 from "/root/workspace/jst-gyl_53Ms/src/models/useRefresh";
import model32 from "/root/workspace/jst-gyl_53Ms/src/models/useShelfTask";
import model33 from "/root/workspace/jst-gyl_53Ms/src/models/useShelvesSuccessRate";
import model34 from "/root/workspace/jst-gyl_53Ms/src/models/useSignAgreement";
import model35 from "/root/workspace/jst-gyl_53Ms/src/models/useSupplierSkuCount";
import model36 from "/root/workspace/jst-gyl_53Ms/src/models/useWechatCode";
// @ts-ignore
import Dispatcher from './helpers/dispatcher';
// @ts-ignore
import Executor from './helpers/executor';
// @ts-ignore
import { UmiContext } from './helpers/constant';

export const models = { '@@initialState': initialState, 'useAfterSalesProcessingResults': model0, 'useAfterSalesQuestionType': model1, 'useAutoAddPriceConfig': model2, 'useBeWorthSell': model3, 'useBreakPriceDrawer': model4, 'useCardInfo': model5, 'useCooActivities': model6, 'useCoopChannelSupplier': model7, 'useDistributionStrategyLog': model8, 'useExperienceFastOrderGoods': model9, 'useExperienceFastOrderGuide': model10, 'useExpressInterception': model11, 'useFindCoopAccess': model12, 'useFreshmanLabelList': model13, 'useGetDistributeAftersaleCount': model14, 'useGoodsChangedNotify': model15, 'useGoodsRule': model16, 'useGoodsShelf': model17, 'useHasBindShop': model18, 'useHasDistributionGoodsData': model19, 'useIKnowSupport': model20, 'useInitAfterSaleSelect': model21, 'useMobileVisitorManageQR': model22, 'usePartnerPublic': model23, 'usePartnership': model24, 'usePerfectExpirePlatform': model25, 'usePlatformAuto': model26, 'usePlatformImageDeals': model27, 'usePriceSyncTool': model28, 'useQueryNotSetDefaultRule': model29, 'useQueryPartnerStatusNum': model30, 'useRefresh': model31, 'useShelfTask': model32, 'useShelvesSuccessRate': model33, 'useSignAgreement': model34, 'useSupplierSkuCount': model35, 'useWechatCode': model36 };

export type Model<T extends keyof typeof models> = {
  [key in keyof typeof models]: ReturnType<typeof models[T]>;
};

export type Models<T extends keyof typeof models> = Model<T>[T]

export const dispatcher = new Dispatcher!();
const Exe = Executor!;

export default ({ children, isCreateAPI }: { children: React.ReactNode }) => {

  return (
    <UmiContext.Provider value={dispatcher}>
      {
        Object.entries(models).map(pair => (
          <Exe key={pair[0]} namespace={pair[0]} hook={pair[1] as any} onUpdate={(val: any) => {
            const [ns] = pair as [keyof typeof models, any];
            
            // createAPI 创建的时候不再重新更新数据
            if(!isCreateAPI){
                dispatcher.data[ns] = val;
                dispatcher.update(ns);
            }
          }} />
        ))
      }
      {children}
    </UmiContext.Provider>
  )
}
